import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, TextField, Typography } from '@material-ui/core';

import { warehouseApi } from 'api/warehouse';
import { FormComponent, Notifications } from 'shared';

import ReceivingCorrectionPreview from './ReceivingCorrectionPreview';

function BulkAdjustUnitsPerCaseAction({ lotId, onCancel, onSuccess, unitsPerCase = 0 }) {
    const [notification, setNotification] = useState({ text: null, level: null });
    const [units, setUnits] = useState(unitsPerCase);
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [correctionData, setCorrectionData] = useState(null);
    const [showConfirmButton, setShowConfirmButton] = useState(false);
    const [adjusting, setAdjusting] = useState(false);

    useEffect(() => {
        if (!(onSuccess instanceof Function)) {
            console.error('BulkAdjustUnitsPerCaseAction intialized incorrectly onSuccess is not a function');
        }
        if (!(onCancel instanceof Function)) {
            console.error('BulkAdjustUnitsPerCaseAction initialized incorrectly onCancel is not a function');
        }
    }, [onSuccess, onCancel]);

    const handleSubmit = async () => {
        if (isNaN(units) || units <= 0) {
            setShowError(true);
            setErrorMessage('Please enter a valid number.');
            return;
        }
        setShowError(false);
        setErrorMessage('');
        setLoading(true);
        setAdjusting(true);

        const requestParams = {
            lotId,
            numUnits: units,
        };

        const result = await warehouseApi.bulkAdjustNumUnits(requestParams);
        setLoading(false);
        setAdjusting(false);
        if (result.status) {
            setShowConfirmButton(false);
            setCorrectionData(result?.data?.result);
            onSuccess();
        } else {
            setNotification({ text: result.msg, level: 'error' });
        }
    };

    const handleFormDataChange = (e) => {
        setUnits(e.target.value);
    };

    const handlePreview = async () => {
        const res = await warehouseApi.getReceivingCorrectionPreview(lotId, units);
        if (!res?.status) {
            setErrorMessage(res?.msg);
            setShowError(true);
            return;
        }
        setShowConfirmButton(true);
        setShowError(false);
        setErrorMessage('');
        setCorrectionData(res?.data?.preview);
    };

    return (
        <>
            <Notifications options={notification} />
            {showError && <Typography style={{ color: 'red', marginBottom: 10 }}>{errorMessage}</Typography>}
            {loading ? (
                <CircularProgress size={24} />
            ) : (
                <form onSubmit={handleSubmit}>
                    <Box display="flex" justifyContent="center" alignItems="center" className="gap-4">
                        <TextField
                            label="Units Per Case"
                            name="unitsPerCase"
                            type="number"
                            value={units}
                            onChange={handleFormDataChange}
                            variant="outlined"
                            margin="dense"
                            inputProps={{ min: 1, step: '1' }}
                            error={units === ''}
                            helperText={units === '' ? 'This field cannot be blank' : ''}
                        />
                        <Button variant="outlined" onClick={handlePreview}>
                            Preview
                        </Button>
                    </Box>
                </form>
            )}
            {correctionData && (
                <>
                    <ReceivingCorrectionPreview correctionData={correctionData} />
                    {showConfirmButton && !showError && (
                        <Button type="submit" variant="outlined" onClick={handleSubmit} disabled={adjusting}>
                            Confirm Adjustment
                        </Button>
                    )}
                    {!showConfirmButton && (
                        <Button variant="outlined" onClick={onCancel}>
                            Done
                        </Button>
                    )}
                </>
            )}
        </>
    );
}

export { BulkAdjustUnitsPerCaseAction };
